module.exports = __webpack_public_path__ + "assets/img/Group3.3019abf6.png";